export default __webpack_public_path__ + "static/media/tanecna-lekcia.c2bd03ed.svg";